import {Grid, IconButton, withStyles} from "@material-ui/core";
import {Info as InfoIcon} from "@material-ui/icons";
import React from "react";
import styles, {LightTooltip} from './styles';

const ListHeaderToolTipLabel = (props) => {
    const {label, text, placement, classes, ...remainingProps} = props;

    return (
        <Grid container className={classes.row} wrap="nowrap">
                <Grid item>
                {label ? label : ''}
                </Grid>
                <Grid item>
                    <LightTooltip title={text ? text : ''} placement={placement} {...remainingProps} >
                        <IconButton size='small' >
                            <InfoIcon fontSize='small' htmlColor='#297ec8'/>
                        </IconButton>
                    </LightTooltip>
                </Grid>
        </Grid>
    )
}

export default withStyles(styles)(ListHeaderToolTipLabel);